module.exports = "/_next/static/files/9fee312b2b354dfec82fd0583d3858cb.png";